export const GET_NEWS = 'GET_NEWS';
export const UPDATE_CHART_INSTANCE = 'UPDATE_CHART_INSTANCE';
export const GET_DESCRIPTION = 'GET_DESCRIPTION';
